import React from 'react'
import { connect } from 'react-redux'

import { Row, Column } from 'components/Layout'
import { FieldFooter } from 'components/Form'
import { Button } from 'components/Button'

import GeneratedAppIcon from 'components/GeneratedAppIcon'
import { IconDropzone } from '../../components/Dropzone'

import { fileUploadRequest, fileUploadClear } from '../../actions'

class FieldIcon extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			currentState: this.props.value !== '' ? 'set' : 'empty',
			displayFile: this.props.value,
			errorMsg: ''
		}
	}

	_changeField = value => {
		const { changeField, fieldId } = this.props
		changeField(fieldId, value)
	}

	_resetField = () => {
		const { changeField, fieldId, value } = this.props
		changeField(fieldId, value)
	}

	_handleUploadedIcon = url => {
		this._changeField(url)
		this.setState({
			displayFile: url,
			currentState: 'set'
		})
	}

	_handleDeleteIcon = () => {
		this._changeField('')
		this.setState({
			displayFile: '',
			currentState: 'empty'
		})
	}

	_handleGenerateClick = e => {
		this.generatedAppIcon && this.generatedAppIcon._generateNewIcon()
	}

	_handleGeneratedImage = imageData => {
		this.setState({
			displayFile: imageData,
			currentState: 'uploading'
		})
	}

	_handleGeneratedFile = imageFile => {
		const { uploadFile, fieldId, customProps: { appId } } = this.props
		uploadFile({
			id: fieldId,
			appId,
			pendingFile: imageFile
		})
	}

	_handleOnFileDropped = (accepted, rejected) => {
		const { uploadFile, fieldId, customProps: { appId } } = this.props
		if (accepted.length > 0) {
			const pendingFile = accepted[0]
			this.setState({
				currentState: 'uploading',
				displayFile: pendingFile.preview
			})
			uploadFile({ id: fieldId, appId, pendingFile })
		} else {
			this._resetField()
			const fileSizeLimit = 1000000
			const rejectedfile = rejected[0]
			this.setState({
				currentState: 'error',
				errorMsg:
					rejectedfile.size > fileSizeLimit
						? 'Whoops! The selected file is bigger than 1MB. Please choose smaller one.'
						: 'Whoops! The selected file is not PNG or JPG. Please choose a file with the correct extension.'
			})
		}
	}

	componentWillReceiveProps(nextProps) {
		const { uploadedFile, clearUploads } = nextProps
		if (uploadedFile && this.props.uploadedFile !== uploadedFile) {
			this._handleUploadedIcon(uploadedFile)
			clearUploads()
		}
	}

	render() {
		const { fieldId, value, disabled } = this.props
		const { currentState } = this.state

		const isUploading = this.state.processing === 'uploading'

		return (
			<Row notPadded>
				<Column notPadded>
					<IconDropzone
						disabled={isUploading || disabled}
						displayFile={this.state.displayFile}
						handleFileDrop={this._handleOnFileDropped}
					/>
				</Column>
				<Column width={6}>
					<p>
						The icon will be displayed within the Apps Marketplace
						and chat.io Agent App. The image has to be at least
						240x240px, in PNG or JPG and less than 1MB.
					</p>
					{(currentState => {
						switch (currentState) {
							case 'empty':
								return (
									<span>
										<GeneratedAppIcon
											themeColor={'#fbb03b'}
											loading={isUploading}
											disabled={disabled}
											ref={ref => {
												this.generatedAppIcon = ref
											}}
											setImageData={
												this._handleGeneratedImage
											}
											setImageFile={
												this._handleGeneratedFile
											}
										/>
										<Button
											loading={this.props.loading}
											disabled={this.props.disabled}
											type={'ghost'}
											onClick={this._handleGenerateClick}
										>
											Generate random
										</Button>
									</span>
								)
							case 'uploading':
								return (
									<Button
										type={'ghost'}
										disabled={true}
										loading={true}
									>
										Uploading...
									</Button>
								)
							case 'error':
								return (
									<FieldFooter
										errorMessage={this.state.errorMsg}
									/>
								)
							case 'set':
								return (
									<Button
										type={'ghost'}
										icon={'delete_forever'}
										disabled={disabled}
										onClick={this._handleDeleteIcon}
									>
										Delete icon
									</Button>
								)
							default:
								return null
						}
					})(currentState)}

					<input type={'hidden'} value={value} id={fieldId} />
				</Column>
			</Row>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		uploadedFile: state.uploads.uploadedItems.iconUrl.url || undefined
	}
}

const mapDispatchToProps = (dispatch, ownProps) => ({
	uploadFile: payload => {
		dispatch(fileUploadRequest(payload))
	},
	clearUploads: payload => {
		dispatch(fileUploadClear())
	}
})

FieldIcon.propTypes = {
	id: React.PropTypes.string,
	error: React.PropTypes.bool
}

const ConnectedFieldIcon = connect(mapStateToProps, mapDispatchToProps)(
	FieldIcon
)

export default ConnectedFieldIcon



// WEBPACK FOOTER //
// ./src/containers/Forms/FieldIcon.js